// src/components/QRScannerComponent.js
import React, { useRef, useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import jsQR from 'jsqr';
import { FaUpload } from 'react-icons/fa'; // ⬅️ for upload icon

const QRScannerComponent = ({ onScanSuccess, onScanError }) => {
  const webcamRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      if (webcamRef.current) {
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
          const img = new Image();
          img.src = imageSrc;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, img.width, img.height);
            const imageData = ctx.getImageData(0, 0, img.width, img.height);
            const code = jsQR(imageData.data, img.width, img.height);
            if (code) {
              console.log('✅ QR Detected:', code.data);
              if (onScanSuccess) {
                onScanSuccess(code.data);
              }
            }
          };
        }
      }
    }, 500); // every half second

    return () => clearInterval(interval);
  }, [onScanSuccess]);

  // 📥 Handle upload QR code manually
  const handleUploadQR = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        const imageData = ctx.getImageData(0, 0, img.width, img.height);
        const code = jsQR(imageData.data, img.width, img.height);
        if (code) {
          console.log('✅ QR Detected from Upload:', code.data);
          if (onScanSuccess) {
            onScanSuccess(code.data);
          }
        } else {
          if (onScanError) {
            onScanError('❌ No QR code detected.');
          }
          alert('❌ No QR code detected. Try again.');
        }
      };
    };
    reader.readAsDataURL(file);
  };

  return (
    <div style={containerStyle}>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          facingMode: "environment", // back camera
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        }}
        style={webcamStyle}
      />
      {/* Center Frame */}
      <div style={frameStyle}></div>

      {/* Scan instruction */}
      <div style={textStyle}>📸 Scan Ticket QR Code</div>

      {/* Upload Button */}
      <div style={uploadContainerStyle}>
        <label htmlFor="uploadQR" style={uploadButtonStyle}>
          <FaUpload size={30} />
          <input
            id="uploadQR"
            type="file"
            accept="image/*"
            onChange={handleUploadQR}
            style={{ display: 'none' }}
          />
        </label>
      </div>

      {error && <div style={{ color: 'red' }}>{error}</div>}
    </div>
  );
};

// 🌟 STYLES

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100vh', // full screen height
  overflow: 'hidden',
  backgroundColor: 'black',
};

const webcamStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const frameStyle = {
  position: 'absolute',
  top: '30%',
  left: '20%',
  width: '60%',
  height: '30%',
  border: '3px solid white',
  borderRadius: '15px',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
};

const textStyle = {
  position: 'absolute',
  top: '65%',
  width: '100%',
  textAlign: 'center',
  fontSize: '18px',
  fontWeight: 'bold',
  color: 'white',
};

const uploadContainerStyle = {
  position: 'absolute',
  bottom: '30px',
  width: '100%',
  textAlign: 'center',
};

const uploadButtonStyle = {
  backgroundColor: '#004aad',
  padding: '10px 20px',
  borderRadius: '50px',
  color: 'white',
  cursor: 'pointer',
  display: 'inline-block',
};

export default QRScannerComponent;
